import { Component, EventEmitter, ViewChild, ViewContainerRef } from '@angular/core';

import {GridApi, IStatusPanelParams} from 'ag-grid-community';
import { PageDirection } from './datagrid.component';

@Component({
  selector: 'vias-datagrid-statusbar-pagination',
  template: `<span class="ag-paging-page-summary-panel" role="presentation">
    <div ref="btFirst" class="ag-paging-button" [class.ag-disabled]="nav[0]" role="button" aria-label="İlk sayfa" tabindex="0" (click)="onFirst()">
        <span class="ag-icon ag-icon-first" unselectable="on" role="presentation"></span>
    </div>
    <div ref="btPrevious" class="ag-paging-button" [class.ag-disabled]="nav[1]" role="button" aria-label="Önceki sayfa" tabindex="0" (click)="onPrevious()">
        <span class="ag-icon ag-icon-previous" unselectable="on" role="presentation"></span>
    </div>
    <span class="ag-paging-description" aria-hidden="false">
        <span id="ag-30-start-page">Sayfa </span>
        <span id="ag-30-start-page-number" ref="lbCurrent" class="ag-paging-number">{{currentPage}}</span>
        <span id="ag-30-of-page"> / </span>
        <span id="ag-30-of-page-number" ref="lbTotal" class="ag-paging-number">{{totalPages}}</span>
    </span>
    <div ref="btNext" class="ag-paging-button" [class.ag-disabled]="nav[2]" role="button" aria-label="Sonraki Sayfa" tabindex="0" (click)="onNext()">
        <span class="ag-icon ag-icon-next" unselectable="on" role="presentation"></span>
    </div>
    <div ref="btLast" class="ag-paging-button" [class.ag-disabled]="nav[3]" role="button" aria-label="Son Sayfa" tabindex="0" (click)="onLast()">
        <span class="ag-icon ag-icon-last" unselectable="on" role="presentation"></span>
    </div>
</span>`,
})
export class StatusBarPaginationComponent {
    private params: IStatusPanelParams;
    private gridApi: GridApi;
    // nav disabled   ilk   once  sonra  son // PageDirection
    nav: boolean[] = [];

    public currentPage: number = 1;
    public totalPages: number = 1;
    public pageChange: EventEmitter<PageDirection> = new EventEmitter();

    agInit(params: IStatusPanelParams): void {
        this.nav[PageDirection.First] = true;
        this.nav[PageDirection.Previous] = true;
        this.nav[PageDirection.Next] = true;
        this.nav[PageDirection.Last] = true;
        this.params = params;
        // this.params.api.addEventListener('gridReady', this.onGridReady.bind(this));
        this.params.api.addEventListener('paginationChanged', this.onPaginationChanged.bind(this));
    }

    // onGridReady(): void {
    //     console.log("gr!@");
    // }
    onPaginationChanged($event): void {
        this.gridApi =  $event.api;

        this.controlPaginationDisabled();
    }

    onFirst(): void {
        if (this.currentPage > 1){
            this.params.api.paginationGoToFirstPage();
            this.pageChange.emit(PageDirection.First);
        }
    }
    onPrevious(): void {
        if (this.currentPage > 1){
            this.pageChange.emit(PageDirection.Previous);
        }
    }
    onNext(): void {
        if (this.currentPage < this.totalPages){
            this.pageChange.emit(PageDirection.Next);
        }
    }
    onLast(): void {
        if (this.currentPage < this.totalPages){
            this.pageChange.emit(PageDirection.Last);
        }
    }

    controlPaginationDisabled(): void {
        if (this.currentPage > 1) {
            this.nav[PageDirection.First] = false;
            this.nav[PageDirection.Previous] = false;
        }
        if (this.currentPage < this.totalPages){
            this.nav[PageDirection.Next] = false;
            this.nav[PageDirection.Last] = false;
        }
    }
}
